import React from 'react';
import PropTypes from 'prop-types';


const freezedOptions = [
  { id: 4, name: 'Excellent', tip: 'Flows naturally, no need to fix any awkward phrases' },
  { id: 3, name: 'Good', tip: 'Flows naturally in general but with a few minor issues' },
  { id: 2, name: 'Poor', tip: 'The text contains several major issues or many minor issues' },
  { id: 1, name: 'Unsatisfactory', tip: 'A pattern of awkward flow throughout the entire text' },
  { id: 0, name: 'Non Applicable', tip: 'Unable to make a judgment because of text type' },
].map(option => Object.freeze(option));
const READABILITY_OPTIONS = Object.freeze(freezedOptions);
const BASE_TEN = 10;
const DEFAULT_OPTION = 5;

class Readability extends React.Component {
  constructor(props) {
    super();
    this.state = {
      dropDownOpen: false,
      selectedOption: props.value == null
        ? Readability.defaultProps.value
        : props.value,
    };
    this.onDropDownClick = this.onDropDownClick.bind(this);
    this.onOptionSelect = this.onOptionSelect.bind(this);
  }

  onDropDownClick() {
    let { dropDownOpen } = this.state;
    dropDownOpen = !dropDownOpen;
    this.setState({ dropDownOpen }, () => {
      if (dropDownOpen) {
        document.body.addEventListener('click', this.onDropDownClick);
      } else {
        document.body.removeEventListener('click', this.onDropDownClick);
      }
    });
  }

  onOptionSelect(optionId) {
    const { selectedOption } = this.state;
    const { onChange } = this.props;
    if (optionId !== selectedOption) {
      this.setState({ selectedOption: parseInt(optionId, BASE_TEN) }, () => {
        onChange(optionId);
      });
    }
  }

  render() {
    const { dropDownOpen, selectedOption } = this.state;
    const { highlightRequired } = this.props;
    const option = READABILITY_OPTIONS.find(x => x.id === selectedOption);
    return (
      <div className="btn-group dropup">
        <button
          type="button"
          className={`btn dropdown-toggle ${highlightRequired ? 'required' : ''}`}
          onClick={this.onDropDownClick}
        >
          <div className="text-container">
            {selectedOption === DEFAULT_OPTION ? (
              <span className="default-dropdown-text">Select your rating</span>
            ) : (
              <div>
                {option.name}
                :
                {' '}
                <span>{option.tip}</span>
              </div>
            )}
          </div>
          <div className="arrow-container">
            <span className="caret" />
            <span className="caret caret-reversed" />
          </div>
        </button>
        {highlightRequired
          && <div className="state-text">Please select your rating</div>}

        <ul
          className="dropdown-menu"
          style={{ display: dropDownOpen ? 'block' : 'none' }}
        >
          {READABILITY_OPTIONS.map(({ id, name, tip }) => (
            <li key={id}>
              <button type="button" data-id={id} className="btn" onClick={() => this.onOptionSelect(id)}>
                <strong>{name}</strong>
                :
                {' '}
                {tip}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

Readability.defaultProps = {
  value: DEFAULT_OPTION,
  highlightRequired: false,
};

Readability.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  highlightRequired: PropTypes.bool,
};

export default Readability;
